module.exports = __webpack_public_path__ + "img/midway.49cdc894.png";